__turbopack_context__.v({
  "crossicon": "GlobalToast-module__M5OQCq__crossicon",
  "error": "GlobalToast-module__M5OQCq__error",
  "info": "GlobalToast-module__M5OQCq__info",
  "slideIn": "GlobalToast-module__M5OQCq__slideIn",
  "success": "GlobalToast-module__M5OQCq__success",
  "toastButtons": "GlobalToast-module__M5OQCq__toastButtons",
  "toastErrMsg": "GlobalToast-module__M5OQCq__toastErrMsg",
  "toastIcon": "GlobalToast-module__M5OQCq__toastIcon",
  "toastMessage": "GlobalToast-module__M5OQCq__toastMessage",
  "toastbody": "GlobalToast-module__M5OQCq__toastbody",
});
